<template>
    <div class="CoverageFormat">
      <head>
        <title>Internet Coverage and Infrastructure in Turkey - inte-QT</title>
        <meta name="title" content="Internet Coverage and Infrastructure in Turkey - inte-QT" />
        <meta name="description" content="Explore inte-QT's internet coverage, submarine cables, mobile broadband, and internet providers in Turkey." />
        <meta name="keywords" content="internet in Turkey, Turkey broadband, fibre optic Turkey, submarine cables Turkey, mobile broadband Turkey, Turkey internet providers" />
        <link rel="canonical" href="https://www.inte-qt.com/coverage/turkey" />
      </head>
      
      <img src="/images/vQIhA63.jpg" alt="Turkey internet infrastructure" class="banner-img CoverageFormat__saturation" />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - In 2021, population for Turkey was 85 million*.</li>
            <li>
              <strong>NEIGHBOURING COUNTRIES*</strong> - Turkey, officially known as the Republic of Turkey, is both a European and an Asian country.
              It's neighbour to the northwest is Bulgaria; Greece to the west; Armenia, Azerbaijan, and Iran to the east; Georgia to the northeast; Syria to the south; and Iraq to the southeast.
            </li>
            <li><strong>LANGUAGE SPOKEN</strong> - Turkish is spoken in Turkey, Cyprus, and elsewhere in Europe and the Middle East.</li>
            <li><strong>CURRENCY</strong> - Turkish Lira</li>
            <li><strong>INDUSTRIES</strong> - Machinery, tourism, textile, electronics, construction, shipbuilding, autos, mining, steel, iron, copper, boron, defence, petroleum, food processing and cotton.</li>
            <li><strong>EMPLOYMENT*</strong> - Employment Rate in Turkey averaged 43.43 percent from 2005 until 2021.</li>
            <li>
              <strong>TOP 3 CITIES</strong>
              <ul>
                <li>Ankara</li>
                <li>Istanbul</li>
                <li>Antalya</li>
              </ul>
            </li>
            <li><strong>WEATHER</strong> - Turkey is situated between the subtropical zone and temperate zone, with Mediterranean climate.</li>
          </ul>
          <div class="text-center">
            <img src="https://gistcdn.githack.com/juan-bits/ca2bc87d6135034900754af8a6295165/raw/bfc7c404e3e12f55f0796b17eb76e141739c0172/turkey-flag.svg" alt="Turkey flag" class="my-5 CoverageFormat__flag" style="width: 150px" />
          </div>
        </nav>
  
        <article>
          <p>
            In 2022, Turkey's authorities decided to rebrand their country's international image. Turkey's President Recep Tayyip Erdoğan issued a communiqué, tweaking the country's internationally recognised name from "Turkey" to Türkiye.
          </p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6349270.021105543!2d30.68882645661244!3d39.01007790330397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b0155c964f2671%3A0x40d9dbd42a625f2a!2sTurkey!5e0!3m2!1sen!2ses!4v1646656939208!5m2!1sen!2ses"
            width="95%" height="450" class="CoverageFormat__margins" style="border: 0" allowfullscreen loading="lazy">
          </iframe>
  
          <h4 class="mt-4">Tourism in Turkey</h4>
          <p>Turkey recorded a total of <strong>52 million* tourists</strong> in 2019, ranking 11th in the world in absolute terms.</p>
          <h4 class="mt-4">Main Ports / Airports in Turkey</h4>
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th scope="col">Rank</th>
                <th scope="col">Airport</th>
                <th scope="col">IATA</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Istanbul Airport</td>
                <td>IST</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Sabiha Gokcen International Airport</td>
                <td>SAW</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Antalya Airport</td>
                <td>AYT</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Ankara Esenboğa Airport</td>
                <td>ESB</td>
              </tr>
            </tbody>
          </table>
  
          <p>
            Turkey has four major container ports: <strong>Haydarpasa, Ambarlı, Izmir, and Mersin</strong>. Except Ambarli, the other three ports are operated by a large governmental agency namely TCDD.
          </p>
  
          <h4 class="mt-5">National Sport of Turkey</h4>
          <p>Oil wrestling ("Yağlı güreş") has been the traditional Turkish national sport since Ottoman times.</p>
  
          <h4 class="mt-5">Typical Turkish Food</h4>
          <p>Turkey's National dish is <strong>döner kebap</strong>, the most common preparations are roasting and grilling, which produce the famous Turkish kebaps.</p>
        </article>
      </section>
  
      <div class="container">
        <h4 class="my-5">Submarine Cables in Turkey</h4>
        <a href="https://www.submarinecablemap.com/country/turkey" rel="noopener noreferrer" target="_blank">
          <img src="/images/dWbnKt9.png" alt="Submarine Cables in Turkey" width="100%" />
        </a>
        <ol class="mt-4">
          <li>Kafos</li>
          <li>MedNautilus Submarine System</li>
          <li>SeaMeWE-3</li>
          <li>SeaMeWe-5</li>
          <li>Turcyos-1</li>
          <li>Turcyos-2</li>
        </ol>
  
        <h4 class="my-4">Internet Access: Landline and Mobile Phone Access in Turkey</h4>
        <p>Total broadband subscribers reached 87.5 million at the end of the third quarter of 2021. In Turkey, fixed broadband usage has increased considerably thanks to Türk Telekom's infrastructure investments since 2005.</p>
  
        <p>On the mobile broadband side, the total number of users was 69.7 million corresponding to 83.4% population penetration rate at the end of Q3'21.</p>
  
        <h4 class="my-4">Internet Providers in Turkey</h4>
        <p>The average download speed is 30.31 Mbps and average upload speed is 8.31 Mbps.</p>
  
        <h4 class="my-4">Our Internet Capabilities in Turkey</h4>
        <p>We provide services in <strong>Antalya, Istanbul, Ankara, and Mersin</strong> with best-in-class fibre access and 24/7 monitoring via our NSOC team.</p>
  
        <table class="table table-striped mb-5">
          <tbody>
            <tr>
              <td>Dedicated Lines</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Business Broadband</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>SLA</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>CPE / Router</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>GEMS</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>Diverse Gateway Solutions</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
            <tr>
              <td>DDoS</td>
              <td><i class="fas fa-check"></i></td>
            </tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins" align="justify">
          With our Global Business Solutions team, we can provide a <mark>Commercial Offer in 2-3 working days</mark> and our Global Ops team is capable of delivering services in the country in 6 to 8 weeks.
        </p>
  
        <p class="text-center">
          For more information, please <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://knoema.com/atlas/Turkey/Population" target="_blank" rel="noopener noreferrer">Reference 1</a></li>
          <li><a href="https://www.flypgs.com/en/travel-guide/general-information-about-turkey" target="_blank" rel="noopener noreferrer">Reference 2</a></li>
          <li><a href="https://www.worldatlas.com/articles/what-languages-are-spoken-in-turkey.html" target="_blank" rel="noopener noreferrer">Reference 3</a></li>
          <li><a href="https://tradingeconomics.com/turkey/employed-persons" target="_blank" rel="noopener noreferrer">Reference 4</a></li>
          <li><a href="http://www.ttyatirimciiliskileri.com.tr/en-us/turk-telekom-group/investing-in-turk-telekom/pages/turkish-telecom-sector.aspx" target="_blank" rel="noopener noreferrer">Reference 5</a></li>
          <li><a href="https://climateknowledgeportal.worldbank.org/country/turkey/climate-data-historical" target="_blank" rel="noopener noreferrer">Reference 6</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'TurkeyPage',
    components: {
      GetInTouch
    }
  };
  </script>
  
  <style scoped>
  .CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  